import { useLayoutEffect } from 'react';
import styled from 'styled-components';

// Enums should match https://docs.affirm.com/affirm-developers/docs/html-reference
export enum AffirmPromotionalClass {
  AsLowAs = 'affirm-as-low-as',
  SiteModal = 'affirm-site-modal',
  ProductModal = 'affirm-product-modal',
}

export enum AffirmPromotionalPageType {
  Homepage = 'homepage',
  Landing = 'landing',
  Search = 'search',
  Category = 'category',
  Product = 'product',
  Cart = 'cart',
  Payment = 'payment',
  Banner = 'banner',
}

export enum AffirmPromotionalType {
  Text = 'text',
  Symbol = 'symbol',
}

interface IAffirmPromotionalProps {
  /**
   * price in USD cents used for calculation of monthly payments
   */
  amount?: number | string;
  /**
   * classname of element used by Affirm SDK to embed content
   */
  affirmClass?: AffirmPromotionalClass;
  /**
   * type of Affirm content to display
   */
  affirmType?: AffirmPromotionalType;
  /**
   * type of page, used to configure content shown
   */
  pageType: AffirmPromotionalPageType;
  /**
   * used for custom styles
   */
  className?: string;
}
/**
 * This component is used for displaying page specific promotional info based on params set
 * inside Affirm.
 *
 * If you need to use this outside of checkout, be sure to include the Affirm script tag and
 * pass in the nonce from getServerSideProps
 *
 * Copied from FC.
 */
export const AffirmPromotional = ({
  amount,
  affirmClass = AffirmPromotionalClass.AsLowAs,
  pageType,
  affirmType = AffirmPromotionalType.Symbol,
  className,
}: IAffirmPromotionalProps) => {
  useLayoutEffect(() => {
    // @ts-ignore global var
    window.affirm?.ui?.ready(() => {
      // @ts-ignore global var
      window.affirm?.ui?.refresh();
    });
  }, [amount]);

  // https://docs.affirm.com/Integrate_Affirm/Direct_API#1._Add_Affirm.js
  return (
    <AffirmPromotional.Root className={className} data-qa="affirm_promotional_offer">
      <p
        className={affirmClass}
        data-page-type={pageType}
        data-affirm-type={affirmType}
        data-amount={amount}
      />
    </AffirmPromotional.Root>
  );
};

AffirmPromotional.Root = styled.div`
  a {
    text-decoration: underline;
  }

  p {
    margin: 0;
    padding-bottom: 16px;
  }
`;
